import _Object$defineProperty from 'babel-runtime/core-js/object/define-property';
import _Object$getOwnPropertyDescriptor from 'babel-runtime/core-js/object/get-own-property-descriptor';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _Symbol from 'babel-runtime/core-js/symbol';
import get from 'lodash/get';

var PROXY_FUNCTION_KEY = _Symbol('proxtFunctionKey');

/**
 * Main goal is to copy getters and methods in a way that:
 *  - Getters doesn't get resolved while being copied.
 *  - Methods get last player reference as `this`. This is important
 *    because methods are called in a different way, not always from player (player.method()).
 */
function extendPlayer(latestPlayer, playerExtension) {
  // Proxy handler is used to set "latest" player as `this` to the player method,
  // regardless of the way the function is called.
  var proxyHandler = {
    get: function get(target, key) {
      // Special key PROXY_FUNCTION_KEY is used to return original method from the proxy,
      // because proxy doesn't provide a way to get the original target.
      // In general, function prototype shouldn't ever change, and could be used to get original method
      // new Proxy(val.prototype.constructor, proxyHandler), but JSDOM, used for snapshots, doesn't create the
      // prototype on the shorthand object methods {method() {}}. If JSDOM/Jest fix the issue, use prototype.
      // In that case only apply accessor is needed.
      if (key === PROXY_FUNCTION_KEY) {
        return target;
      }
      return target[key];
    },
    apply: function apply(target, thisArg, args) {
      return target.apply(latestPlayer, args);
    }
  };

  _Object$keys(playerExtension).forEach(function (key) {
    // Descriptor copies getter without resolving.
    // If getter would be resolved before player is completely merged it could have wrong value because
    // of the wrong `this`. This is true when an extended getter that is used in a non-extended getter.
    var desc = _Object$getOwnPropertyDescriptor(playerExtension, key);

    if (typeof desc.value === 'function') {
      // Proxying Player methods so that `this` is pointing to the latest player.
      // Bind doesn't fit, because bind `this` can't be overridden.
      var func = get(desc.value, PROXY_FUNCTION_KEY, desc.value);
      desc.value = new Proxy(func, proxyHandler);
    }

    _Object$defineProperty(latestPlayer, key, desc);
  });
}

export function mergePlayers() {
  var p1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var p2 = arguments[1];

  var newPlayer = {};

  extendPlayer(newPlayer, p1);
  extendPlayer(newPlayer, p2);

  return newPlayer;
}